<template>
  <router-link
    :to="calloutRoute"
    data-test="training-callout"
    class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 rounded-xl bg-purple-50 border border-purple-100 p-5 hover:shadow-md transition-shadow"
  >
    <div class="min-w-0">
      <h3 class="text-lg font-bold text-gray-900">{{ trainingModule.title }}</h3>
      <p v-if="hasStats" class="mt-1 text-sm text-gray-600">
        {{ t("sellers_trained", { passed: passedCount, total: totalSellers, percent: passedPercent }) }}
      </p>
      <p v-else class="mt-1 text-sm text-gray-400 italic">{{ t("no_stats") }}</p>
    </div>
    <span
      class="inline-flex items-center gap-2 rounded-2xl bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white whitespace-nowrap self-start sm:self-auto"
    >
      {{ t("start_module_button") }}
      <AcademicCapIcon class="h-4 w-4" />
    </span>
  </router-link>
</template>

<script>
import { AcademicCapIcon } from "@heroicons/vue/outline";
import { useI18n } from "vue-i18n";

// Training of the team on the POS home: the module to pass, how many sellers passed it, and a one-click access.
export default {
  components: {
    AcademicCapIcon,
  },
  props: {
    trainingModule: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  computed: {
    calloutRoute() {
      return `/pos/training/module/${this.trainingModule.id}`;
    },
    stats() {
      return this.trainingModule.trainingStats;
    },
    hasStats() {
      return this.stats && this.stats.totalSellers > 0;
    },
    totalSellers() {
      return this.stats?.totalSellers ?? 0;
    },
    passedCount() {
      return this.stats?.passedCount ?? 0;
    },
    passedPercent() {
      if (this.totalSellers === 0) return 0;
      return Math.round((this.passedCount / this.totalSellers) * 100);
    },
  },
};
</script>

<i18n src="./QuizCallout.i18n.json"></i18n>
